import { FilterOption } from '@/components/filter-system';
import { Segment } from './types';

export const SEGMENT_SIZE = {
  SMALL: 1000,
  MEDIUM: 10000
} as const;

export type SegmentSize = 'small' | 'medium' | 'large';

export const getSegmentSize = (total: number): SegmentSize => {
  if (total < SEGMENT_SIZE.SMALL) return 'small';
  if (total < SEGMENT_SIZE.MEDIUM) return 'medium';
  return 'large';
};

export const getTotalSubscribers = (channelCounts: Segment['channelCounts']): number =>
  channelCounts.push + channelCounts.sms + channelCounts.email;

export const sizeFilterOptions: FilterOption<SegmentSize>[] = [
  {
    value: 'small',
    label: `< ${SEGMENT_SIZE.SMALL.toLocaleString()}`
  },
  {
    value: 'medium',
    label: `${SEGMENT_SIZE.SMALL.toLocaleString()} - ${SEGMENT_SIZE.MEDIUM.toLocaleString()}`
  },
  {
    value: 'large',
    label: `> ${SEGMENT_SIZE.MEDIUM.toLocaleString()}`
  }
];
